"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoDays = void 0;
var isoDays;
(function (isoDays) {
    isoDays[isoDays["MON"] = 1] = "MON";
    isoDays[isoDays["TUE"] = 2] = "TUE";
    isoDays[isoDays["WED"] = 3] = "WED";
    isoDays[isoDays["THUR"] = 4] = "THUR";
    isoDays[isoDays["FRI"] = 5] = "FRI";
    isoDays[isoDays["SAT"] = 6] = "SAT";
    isoDays[isoDays["SUN"] = 7] = "SUN";
})(isoDays || (exports.isoDays = isoDays = {}));
exports.default = isoDays;
